export default __webpack_public_path__ + "static/media/miut-gatian-concept-art.d8983981.jpeg";